module.exports = __webpack_public_path__ + "gdocket-62c7051e.png";